import { motion } from 'framer-motion';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function Toast({
    id,
    message,
    type,
    onClose,
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
        >
            <Alert
                severity={type}
                variant='filled'
                action={
                    <IconButton
                        aria-label='close'
                        color='inherit'
                        size='small'
                        onClick={() => onClose(id)}
                    >
                        <CloseIcon fontSize='inherit' />
                    </IconButton>
                }
            >
                {message}
            </Alert>
        </motion.div>
    );
}
